import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";

export interface GetTablesParams {
  cpf: string;
  matricula?: string;
  quantidadeParcelas?: number;
  Prazo?: number;
  valorFinanciado?: number;
  valorParcela?: number;
}

export interface ILiberacao {
  NumeroLiberacao: number;
  TipoBeneficiario: string;
  NumeroContrato?: string;
  Valor: number;
}

export interface IStatusProcessamento {
  Status: boolean;
  MensagemErro: string;
}

export interface ITableClt {
  ID: number;
  NomeTabela?: string;
  CodigoPromotora: number;
  CodigoEmpregador: number;
  CodigoTabela: number;
  Prazo: number;
  Coeficiente: number;
  Taxa: number;
  TaxaCusto: number;
  ValorTC: number;
  ValoeDespesa: number;
  Carencia: number;
  PorcentagemComissao: number;
  PorcentagemCessao: number;
  IntegracaoOnline: boolean;
  CodigoProduto: number;
  CodigoClubeBeneficios: number;
  CodigoProdutoExterno: number;
  Ativo: boolean;
  TipoDeCalculo: string;
  TipoFormalizacao: string;
  TipoCalculoSimulacao: string;
  IDTemplateCCB?: string;
  NumeroCessao?: number;
  ExibirTabelaSimulacao?: boolean;
  IDRebates?: number;
  IDDistribuicao?: number;
  DataDeCadastro: string;
  DataDeAlteracao: string;
  UsuarioCadastro: string;
  UsuarioAlteracao: string;
  ValorMinimoOperacao: number;
  TipoValorTC: string;
  IdTabela: number;
  ValorParcela: number;
  TaxaAP_AM: number;
  TaxaAP_AA: number;
  TaxaNominal_AM: number;
  TaxaNominal_AA: number;
  TaxaCliente_AM: number;
  TaxaCliente_AA: number;
  TaxaCET_AM: number;
  TaxaCET_AA: number;
  CodigoOrgao: number;
  ValorSolicitado: number;
  ValorFinanciado: number;
  ValorIOC: number;
  ValorSeguro: number;
  DataPrimeiroVencimento: string;
  DataUltimoVencimento: string;
  ValorLiquidoCliente: number;
  ValorBruto?: number;
  IDTabela?: number;
  commission?: number;
  bonus?: number;
  tableName?: string;
  tableCode: string;
}

export interface ITableCltResponse {
  prazos: number[];
  prazoSelecionado?: number | null;
  tables: ITableClt[];
  matricula: number;
  cnpjEmpresa: number;
  valorParcelaMaximo?: number;
  message?: string;
}

export const getTables = async (params: GetTablesParams) => {
  const { data } = await httpClient.post<ITableCltResponse>(
    "/clt/getTables",
    params,
    { journey: PartnerType.CLT },
  );
  return data;
};
